import React, {Component} from 'react'
import {observer} from 'mobx-react'

import SettingsGroup from '../../../struct/SettingsGroup'
import TagSourceField from '../../../struct/TagSourceField'
import OfferFieldValueSourceSelect from './OfferFieldValueSourceSelect'
import OfferFieldsMarkupsField from './OfferFieldsMarkupsField'
import profileOfferSettings from "../../../../store/ProfileOfferSettings"
import OfferCustomParamsSettings from "./custom_params/OfferCustomParamsSettings"

@observer export default class ProfileOfferFieldMappingSettings extends Component {
    render() {
        const {title} = this.props
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const offerFields = profileOfferSettings.fields
        const offerFieldsKeys = Object.keys(offerFields)
        /** @type {ProfileSettings} */
        const profile = context.profile
        return (
            <SettingsGroup title={title}>
                {offerFieldsKeys.map((key) => {
                        /** @type {Field} */
                        const field = offerFields[key]
                        if (!field.isConditionsMet()) {
                            return null
                        }

                        return (
                            <div key={key}>
                                <TagSourceField
                                    label={field.name}
                                    tag={field.tag}
                                    hint={field.hint}
                                    key={key}
                                    indent_label={field.parent}
                                    type={field.type}
                                    required={field.required}
                                    profile={profile}
                                    field={field}
                                >
                                    <OfferFieldValueSourceSelect
                                        context={context}
                                        value_source={field.value}
                                        field={field.dataset}
                                        fieldObject={field}
                                    />
                                </TagSourceField>
                                {field.markups && <OfferFieldsMarkupsField
                                    context={context}
                                    field={field}
                                    profile={profile}
                                    markups={field.markups}
                                    label={'Наценка'}
                                    indent_label={true}
                                />}
                            </div>)
                    }
                )}
                <OfferCustomParamsSettings
                    context={context}
                    custom_params={profile.offer_field_mapping_custom_params}
                    addCustomParam={(param_params) => profile.addNewSimpleCustomParam(param_params)}
                    deleteCustomParam={param => profile.deleteSimpleCustomParam(param)}
                />
            </SettingsGroup>
        )
    }

}